import React, { memo } from 'react';
import { Tooltip } from 'antd';
import Btn from '../../../../../components/btn';
import { useEvent } from '../../../../../hooks/useEvent';
import styles from './index.module.scss';

const Toggler = ({ items, size, value, onChange, btnCN, disabled }) => {
  return items?.length ? (
    <Content
      items={items}
      size={size}
      value={value}
      onChange={onChange}
      btnCN={btnCN}
      disabled={disabled}
    />
  ) : null;
};

export default Toggler;

const MemoizedAction = memo(Action);
function Content({ items, size = 'lg', value, onChange, btnCN, disabled }) {
  const handleChange = useEvent(onChange);

  return (
    <div className={styles.root}>
      {items.map((item) => (
        <MemoizedAction
          {...item}
          key={item.value}
          className={btnCN}
          size={size}
          isActive={value === item.value}
          onClick={handleChange}
          disabled={disabled}
        />
      ))}
    </div>
  );
}

function Action({
  value,
  label,
  className,
  size,
  isActive,
  onClick,
  tooltipTitle,
  disabled,
}) {
  return (
    <Tooltip title={tooltipTitle}>
      <Btn
        className={className}
        size={size}
        type={isActive ? 'primary' : 'secondary'}
        onClick={(e) => onClick(value, e)}
        disabled={disabled}
      >
        {label}
      </Btn>
    </Tooltip>
  );
}
